var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-agent-alert",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-access" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          return _vm.no()
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-header" }, [
                    _c("div", { staticClass: "go-msg-title" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("briefing.popup.action.title", {
                              state:
                                _vm.state == 1
                                  ? _vm
                                      .$t("invitationCode.deactive")
                                      .toString()
                                      .toLocaleLowerCase()
                                  : _vm
                                      .$t("invitationCode.active")
                                      .toString()
                                      .toLocaleLowerCase(),
                              bfName: _vm.bfName,
                            })
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-body" }, [
                    _c("span", { staticClass: "go-text-sub" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.action.description." +
                                (_vm.state == 1 ? "deactivate" : "activate")
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          disabled: _vm.isLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.no()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("entity.action.cancel")) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { type: "button", disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            return _vm.yes()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("entity.action.save")))]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }